import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['mandatoryGroup', 'submit', 'unansweredNotice'];
  static values = { otherPagesAnswered: Boolean };

  connect() {
    this.updateSubmitState();
  }

  updateSubmitState() {
    if (!this.hasSubmitTarget) return;

    const currentPageSatisfied = this.mandatoryGroupTargets.every(
      (group) => this._groupSatisfied(group)
    );
    const canSubmit = this.otherPagesAnsweredValue && currentPageSatisfied;

    this.submitTarget.disabled = !canSubmit;

    // The notice is rendered once and would otherwise keep saying an answer is
    // missing while Submit sits there enabled.
    if (this.hasUnansweredNoticeTarget) {
      this.unansweredNoticeTarget.classList.toggle('hidden', canSubmit);
    }
  }

  _groupSatisfied(group) {
    const radios = Array.from(group.querySelectorAll('input[type=radio]'));
    if (radios.length) {
      return this._radioGroupsSatisfied(radios);
    }

    const checkboxes = group.querySelectorAll('input[type=checkbox]');
    if (checkboxes.length) {
      return Array.from(checkboxes).some((el) => el.checked);
    }

    const textFields = group.querySelectorAll('input[type=text], textarea');
    return Array.from(textFields).some((el) => el.value.trim() !== '');
  }

  // Grid puts one radio group per statement in a mandatoryGroup; each name must be satisfied.
  _radioGroupsSatisfied(radios) {
    const byName = new Map();

    radios.forEach((radio) => {
      if (!byName.has(radio.name)) byName.set(radio.name, []);
      byName.get(radio.name).push(radio);
    });

    return Array.from(byName.values()).every((named) => named.some((el) => el.checked));
  }
}
